export function setPageMetadata(title: string, robots: 'index,follow' | 'noindex,nofollow') {
  document.title = title
  let robotsTag = document.querySelector<HTMLMetaElement>('meta[name="robots"]')
  if (!robotsTag) {
    robotsTag = document.createElement('meta')
    robotsTag.name = 'robots'
    document.head.append(robotsTag)
  }
  robotsTag.content = robots
}
